var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex justify-content-center align-items-center mt-2",
      attrs: { id: "etiquetas" }
    },
    [
      _vm.escolha == 1
        ? _c("div", { staticClass: "d-flex flex-column m-1" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1)
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.escolha == 2
        ? _c("div", { staticClass: "d-flex flex-column m-1" }, [
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3)
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.escolha == 3
        ? _c("div", { staticClass: "d-flex flex-column m-1" }, [
            _vm._m(4),
            _vm._v(" "),
            _vm._m(5)
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.escolha == 4
        ? _c("div", { staticClass: "d-flex flex-column m-1" }, [
            _vm._m(6),
            _vm._v(" "),
            _vm._m(7)
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex mb-3" }, [
      _c("div", { staticClass: "etiquetas" }, [
        _c(
          "div",
          {
            staticClass:
              "c-etiqueta rounded d-flex flex-column align-items-center justify-content-between p-2"
          },
          [
            _c("div", { staticClass: "text-left w-100" }, [
              _c("h3", { staticClass: "titulo m-0" }, [
                _c("b", [_vm._v("0000 - Nome do Produto")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center h-100" }, [
              _c("div", [
                _c("p", { staticClass: "valor" }, [
                  _c("b", [_vm._v("R$ 99,99")])
                ])
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("h6", { staticClass: "mb-2" }, [
          _c("b", [_vm._v("Informações do Papel:")])
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Pimaco Cod.: A4256 ou A4 Comum")]),
        _vm._v(" "),
        _c("p", [_vm._v("25,4mm x 63,5mm")]),
        _vm._v(" "),
        _c("p", [_vm._v("33 Etiquetas Por Pagina")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("p", [
        _c("b", [_vm._v("Exemplo de Digitação por Linha:")]),
        _vm._v(" 0000 - Nome do Produto;99,99")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex mb-3" }, [
      _c("div", { staticClass: "etiquetas" }, [
        _c(
          "div",
          {
            staticClass:
              "c-etiqueta rounded d-flex flex-column align-items-center justify-content-between p-2"
          },
          [
            _c("div", { staticClass: "text-left w-100" }, [
              _c("h3", { staticClass: "titulo" }, [
                _c("b", [_vm._v("0000 - Nome do Produto")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center h-100" }, [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column de-caixa text-center" },
                  [
                    _c("div", { staticClass: "corte" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "de m-0" }, [
                      _c("b", [_vm._v("DE: R$ 99,99")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "por" }, [
                  _c("b", [_vm._v("POR: R$ 49,99")])
                ])
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("h6", { staticClass: "mb-2" }, [
          _c("b", [_vm._v("Informações do Papel:")])
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Pimaco Cod.: A4256 ou A4 Comum")]),
        _vm._v(" "),
        _c("p", [_vm._v("25,4mm x 63,5mm")]),
        _vm._v(" "),
        _c("p", [_vm._v("33 Etiquetas Por Pagina")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _c("b", [_vm._v("Exemplo de Digitação por Linha:")]),
        _vm._v(" 0000 - Nome do Produto;99,99;49,99")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex mb-3" }, [
      _c("div", { staticClass: "etiquetas" }, [
        _c(
          "div",
          {
            staticClass:
              "c-etiqueta rounded d-flex flex-column align-items-center justify-content-between p-2"
          },
          [
            _c("div", { staticClass: "text-left w-100" }, [
              _c("h3", { staticClass: "titulo m-0" }, [
                _c("b", [_vm._v("0000 - Nome do Produto")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center h-100" }, [
              _c("div", [
                _c("p", { staticClass: "valor" }, [
                  _c("b", [_vm._v("R$ 99,99")])
                ])
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("h6", { staticClass: "mb-2" }, [
          _c("b", [_vm._v("Informações do Papel:")])
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Pimaco Cod.: A4251, A4351 A4 ou A4 Comum")]),
        _vm._v(" "),
        _c("p", [_vm._v("21,2mm x 38,2mm")]),
        _vm._v(" "),
        _c("p", [_vm._v("65 Etiquetas Por Pagina")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("p", [
        _c("b", [_vm._v("Exemplo de Digitação por Linha:")]),
        _vm._v(" 0000 - Nome do Produto;99,99")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex mb-3" }, [
      _c("div", { staticClass: "etiquetas" }, [
        _c(
          "div",
          {
            staticClass:
              "c-etiqueta rounded d-flex flex-column align-items-center justify-content-between p-2"
          },
          [
            _c("div", { staticClass: "text-left w-100" }, [
              _c("h3", { staticClass: "titulo" }, [
                _c("b", [_vm._v("0000 - Nome do Produto")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center h-100" }, [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column de-caixa text-center" },
                  [
                    _c("div", { staticClass: "corte" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "de m-0" }, [
                      _c("b", [_vm._v("DE: R$ 99,99")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "por" }, [
                  _c("b", [_vm._v("POR: R$ 49,99")])
                ])
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("h6", { staticClass: "mb-2" }, [
          _c("b", [_vm._v("Informações do Papel:")])
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Pimaco Cod.: A4251, A4351 A4 ou A4 Comum")]),
        _vm._v(" "),
        _c("p", [_vm._v("21,2mm x 38,2mm")]),
        _vm._v(" "),
        _c("p", [_vm._v("65 Etiquetas Por Pagina")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _c("b", [_vm._v("Exemplo de Digitação por Linha:")]),
        _vm._v(" 0000 - Nome do Produto;99,99;49,99")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-888f2416", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-888f2416","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Etiquetas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-888f2416","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Etiquetas.vue
// module chunks = 2